export default "__VITE_ASSET__969a6c3b__"